// Render-only view of the sample-return state.
//
// The state itself is derived SERVER-SIDE by `backend/return_state.py` and
// arrives on the booking as `return_state`, so the admin list, the customer
// chase email, the office digest and the partner metric can never drift
// apart. This module only turns it into pixels.

export const RETURN_STATES = {
  NOT_AVAILABLE: "not_available",
  AWAITING_CUSTOMER_RETURN: "awaiting_customer_return",
  IN_TRANSIT: "in_transit",
  RECEIVED: "received",
};

/** @returns null when there is nothing to show in the list. */
export function returnStateChip(booking = {}) {
  const st = (booking || {}).return_state;
  if (!st || st.state === RETURN_STATES.RECEIVED
    || st.state === RETURN_STATES.NOT_AVAILABLE) return null;
  if (st.overdue) {
    return { kind: "overdue", text: `Overdue ${st.days_overdue}d`, title: st.detail };
  }
  if (st.state === RETURN_STATES.AWAITING_CUSTOMER_RETURN) {
    return { kind: "awaiting", text: st.label, title: st.detail };
  }
  return { kind: "eta", text: st.label, title: st.detail };
}
